"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils

/* ++++++++++ --------------- EMPTY STATE : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'EmptyState',
  group: _definitionhelpers.groupNames.states,
  props: {
    graphicName: {
      type: 'string',
      default: 'error-404',
      options: ['placeholder', 'error-403', 'error-404', 'error-500', 'insight', 'paintbrush', 'embed', 'email', 'payment', 'mobile', 'desktop', 'insticator-icon']
    },
    graphicText: {
      type: 'string'
    },
    buttonName: {
      type: 'string',
      name: 'calltoaction'
    },
    buttonText: {
      type: 'string',
      default: "Call to Action"
    },
    bodycopy: {
      type: 'object',
      default: _react.default.createElement("span", null, "There is nothing here yet.", _react.default.createElement("br", null), _react.default.createElement("br", null), _react.default.createElement("strong", null, "Create something"), " and you will see it populate here.")
    },
    buttonClick: {
      type: 'function',
      default: function _default() {
        return console.log('calltoaction clicked');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;